// Add to cart effects
document.addEventListener("DOMContentLoaded", () => {
  const stickyContainer = document.querySelector(".custom-atc_wrapper");
  const atcButtons = document.querySelector(".main_atc");
  const customPdpWrapper = document.querySelector(".custom_pdp_wrapper");
  const footer = document.querySelector("footer");
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  stickyContainer.style.display = "none";

  const hideSticky = () => {
    stickyContainer.style.display = "none";
    stickyContainer.classList.remove("sticky");
  };

  const showSticky = () => {
    stickyContainer.style.display = "block";
    stickyContainer.classList.add("sticky");
  };

  // Intersection Observer for footer
  let footerInView = false;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        footerInView = entry.isIntersecting;
        if (footerInView) {
          hideSticky();
        } else if (window.scrollY > customPdpWrapper.offsetTop + customPdpWrapper.offsetHeight) {
          showSticky();
        }
      });
    },
    { rootMargin: "0px", threshold: 0.1 }
  );

  if (footer) observer.observe(footer);

  if (!isMobile) {
    atcButtons.style.display = "block";

    window.addEventListener("scroll", () => {
      const customPdpBottom = customPdpWrapper.getBoundingClientRect().bottom;

      if (customPdpBottom <= 0 && !footerInView) {
        atcButtons.style.display = "none";
        showSticky();
      } else {
        atcButtons.style.display = "block";
        hideSticky();
      }
    });
  } else {
    // Always sticky for mobile unless footer is in view
    // atcButtons.style.display = "none";
  

    window.addEventListener("scroll", () => {
       const customPdpBottom = customPdpWrapper.getBoundingClientRect().bottom - 400;

           if (customPdpBottom <= 0 && !footerInView) {
        atcButtons.style.display = "none";
        showSticky();
      } else {
        atcButtons.style.display = "block";
        hideSticky();
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggle = document.getElementById("dropdownToggle");
  const dropdown = document.querySelector(".custom-dropdown");
 
  // Toggle dropdown visibility
  dropdownToggle.addEventListener("click", function () {
    dropdown.classList.toggle("open");
  });

  // Close dropdown on outside click
  document.addEventListener("click", function (event) {
    if (!dropdown.contains(event.target)) {
      dropdown.classList.remove("open");
    }
  });


   const selectedText = document.getElementById("dropdownSelectedText");
   const dropdownItems = document.querySelectorAll(".custom-dropdown .dropdown-item");

  // Handle dropdown item click
  dropdownItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const handle = item.getAttribute("data-handle");
      const itemImg = item.querySelector("img");
      const flavourText = item.querySelector(".flavour_name");

      // Remove 'active' class from all
      dropdownItems.forEach(function (el) {
        el.classList.remove("active");
      });

      // Add 'active' to clicked item
      this.classList.add("active");

      // ✅ Update the dropdown display
      if (itemImg && flavourText) {
        selectedText.innerHTML = `
          <img src="${itemImg.src}" alt="${itemImg.alt}">
          <span class="selected_flavour">${flavourText.textContent}</span>
        `;
      }

      // ✅ Optional: update gallery if handle is available
      if (handle) {
        console.log("Handle updated:", handle);
        updateProductMediaByHandle(handle.replace('/fr',''));
        fetchProductMetafields(handle.replace('/fr',''));
        // const productHandle = this.getAttribute('data-handle');

        if (handle.includes('/fr')) {
        var productHandle = this.getAttribute('data-handle').replace('/fr', '');
        var newUrl = '/fr/products/'+productHandle;
        console.log(newUrl);
        }
        else{
        var productHandle = this.getAttribute('data-handle');
        var newUrl = '/products/'+productHandle;
        }
        
        // const newUrl = '/products/'+productHandle;
        window.history.pushState({}, '', newUrl);
        console.log(productHandle);
      } else {
        console.warn("No product handle found on clicked item.");
      }

      dropdown.classList.remove("open");
    });
  });

  

});

function redirectToLink(url) {
  if (url) {
    window.location.href = url;
  }
}

document.querySelectorAll('input[name="purchase-type"]').forEach((input) => {
  input.addEventListener("change", function () {
    console.log(`Selected option: ${this.value}`);
    // You can trigger additional actions like updating the Add to Cart button or showing/hiding details
  });
});

const metafieldsMap = JSON.parse(document.getElementById('variant-metafields-json').textContent);
const ctaContainer = document.querySelector(".atc_buttons");

document.addEventListener("change", function (e) {
  if (e.target.name === 'id') {
    const variantId = e.target.value;
    const data = metafieldsMap[variantId];

    // Get the "Buy Now" and "Add to Cart" buttons
    const buyNowButton = document.getElementById("buy-now-button");
    const addToCartButton = document.querySelector(".redirect_atc_hide");

    if (data?.enable_redirect && data?.redirect_link) {
      // If redirect is enabled, show "Buy Now" and hide "Add to Cart
      buyNowButton.classList.remove("hidden");
      addToCartButton.classList.add("hidden");
      
      // Update the "Buy Now" button with the link from metafield
      buyNowButton.href = data.redirect_link;
    } else {
      // If no redirect is enabled, show "Add to Cart" and hide "Buy Now"
       buyNowButton.classList.add("hidden");
      addToCartButton.classList.remove("hidden");
    }
  }
});


